// alert("HELLO APP.JS");
app = {
	//////////////////////////////////////////////
	//! Dispatcher
	//////////////////////////////////////////////
	dispatcher: new Dispatcher(),

	//////////////////////////////////////////////
	//! Settings and Tracking
	//////////////////////////////////////////////
	scrollPos: {
		tracked: 0,
		stored: 0,
	},

	menuPanel: {
		isOpen: false,
	},

	searchPanel: {
		isOpen: false,
		scrollPos: 0, // track the scroll pos when search is opened
	},

	modal: {
		isOpen: false,
		isFilter: false,
	},

	wpdata: $(DOM.data),

	wp: {
		ajaxUrl: $(DOM.data).data("wpajaxurl"),
		siteUrl: $(DOM.data).data("wpsiteurl"),
		themUrl: $(DOM.data).data("wpthemeurl"),
	},

	page: {
		template: $(DOM.data).data("pgtemplate"), // archive / page / single
		postType: $(DOM.data).data("pgtype"), // post type
		name: $(DOM.data).data("pgname"), // page name
		paged: {
			min: $(DOM.data).data("pgnumber"), // track lowest loaded page
			max: $(DOM.data).data("pgnumber"), // track highest loaded page
		},
		isBusy: false, // Page is doing soemthing (use to blockj other actions)
		last_scroll: 0,
		currentColor: $(DOM.data).data("currentcolor"),
	},

	maps: {}, // storage for maps
	team: {}, // storage for teams

	scroll: {}, // storage for custom scrollbars

	filterQueries: {
		// QUERIES BY TAXONOMY
		location_prime: [-1],
		sector: [-1],
		service: [-1],
	},

	posts: {}, // store posts from api requests here

	ajaxReq: false,

	//////////////////////////////////////////////
	//! INNIT FUNCTIONS
	//////////////////////////////////////////////
	init: function () {
		//alert('app.init')

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - Add Views
		//::::::::::::::::::::::::::::::::::::::::::::
		//app.view = new someView(app.dispatcher);

		//Call bind events
		app.bindEvents(); // Global events
		app.dispatcher.dispatch(EVENTS.PAGE.READY, [
			app.page.postType,
			app.page.name,
			app.page.template,
		]);
	},

	//////////////////////////////////////////////
	//! EVENTS
	//////////////////////////////////////////////
	bindEvents: function () {
		//::::::::::::::::::::::::::::::::::::::::::::
		//! - PAGE READY EVENT
		//::::::::::::::::::::::::::::::::::::::::::::
		app.dispatcher.addEventListener(
			EVENTS.PAGE.READY,
			app.pageReadyEvents.bindX(this)
		);

		//::::::::::::::::::::::::::::::::::::::::::::
		//! Form Styles
		//::::::::::::::::::::::::::::::::::::::::::::
		$("select").selectric({
			inheritOriginalWidth: true,
			allowWrap: false,
			maxHeight: 999,
			nativeOnMobile: false,
		});

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - IN SITE LINKS FOR PAGE LOAD FX
		//::::::::::::::::::::::::::::::::::::::::::::
		$('a[href^="' + app.wp.siteUrl + '"]').click(function () {
			$(DOM.page.el).addClass("is-loading");
		});

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - MENU TOGGLES
		//::::::::::::::::::::::::::::::::::::::::::::
		$(DOM.btn.menuOpen).click(function () {
			// menu butn in navbar
			app.menuToggle(true); // open menu
		});

		$(DOM.btn.menuClose).click(function () {
			app.menuToggle(false); // close menu
		});

		$(DOM.ui.mnuPanel + " a").click(function () {
			// page & footer click

			app.menuToggle(false); // close menu
		});

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - SEARCH TOGGLES
		//::::::::::::::::::::::::::::::::::::::::::::
		$(DOM.btn.searchTogg)
			.unbind("click")
			.click(function () {
				// menu butn in navbar
				app.searchToggle();
			});

		app.dispatcher.addEventListener(
			EVENTS.WINDOW.SCROLL,
			function (event, data) {
				var scrollTop = data[0];

				if (
					app.searchPanel.isOpen === true &&
					Math.abs(scrollTop - app.searchPanel.scrollPos) >= 200
				) {
					app.searchToggle("close"); // close the search panel
				}
			}.bindX(this)
		);

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - INFINATE SCROLL TRIGGERS
		//::::::::::::::::::::::::::::::::::::::::::::
		$(DOM.btn.loadmore).click(function () {
			// next btn
			app.loadmoreInit(true);
		});

		$(DOM.btn.loadprev).click(function () {
			// prev btn
			app.loadmoreInit(false);
		});

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - MASTHEAD SCROLL BUTTON
		//::::::::::::::::::::::::::::::::::::::::::::
		$(DOM.btn.mastScroll).click(function (e) {
			e.preventDefault();
			var vpH = $(window).height();

			$("html, body").animate(
				{
					scrollTop: vpH - 100,
				},
				1500
			);
		});

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - VIDEO BKG DETECTION
		//::::::::::::::::::::::::::::::::::::::::::::
		$(DOM.video.auto).each(function () {
			app.videoSrcCheck($(this));
		});

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - MODAL WINDOW TOGGLES
		//::::::::::::::::::::::::::::::::::::::::::::

		$(DOM.modal.open).click(function (e) {
			e.preventDefault();
			app.modalOpen($(this), null);
		});

		$(DOM.modal.close).click(function () {
			app.modalCLose();
		});

		$(DOM.modal.filters.open).click(function () {
			app.modalFilters();
		});

		//$(DOM.modal.content).tinyscrollbar();

		app.scroll.modal = new SimpleBar($(DOM.modal.content)[0], {
			autoHide: false,
		});

		app.scroll.filters = new SimpleBar($(DOM.filtersBar.scroll)[0], {
			autoHide: false,
		});

		//::::::::::::::::::::::::::::::::::::::::::::
		//! - OVERLAY Events
		//::::::::::::::::::::::::::::::::::::::::::::
		$(DOM.ui.overlay).click(function () {
			app.modalCLose();
			app.menuToggle(false);
		});

		//::::::::::::::::::::::::::::::::::::::::::::
		//! Activate slideshow modules
		//::::::::::::::::::::::::::::::::::::::::::::
		$(DOM.ui.slideshow).each(function () {
			app.slideShow($(this));
		});
	},

	//////////////////////////////////////////////
	//! PAGE READY EVENTS
	//////////////////////////////////////////////
	pageReadyEvents: function (e, d) {
		//alert('PAGE: '+d[0]);
		$(DOM.page.el).removeClass("is-loading");

		//console.log(d);

		// d[0] = postType
		// d[1] = pageName
		// d[2] = PageTemplate

		// Options based on type
		switch (d[0]) {
			//::::::::::::::::::::::::::::::::::::::::::::
			//! - STATIC PAGE EVENTS
			//::::::::::::::::::::::::::::::::::::::::::::
			case "page":
				// Options based on name
				switch (d[1]) {
					//::::::::::::::::::::::::::::::::::::::::::::
					//! - PAGE - ASSAEL EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "assael":
						break;

					//::::::::::::::::::::::::::::::::::::::::::::
					//! - PAGE - ABOUT EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "about":
						app.filterTeam();

						break;

					//::::::::::::::::::::::::::::::::::::::::::::
					//! - PAGE - CONTACT EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "contact":
						$(DOM.maps.el).each(function () {
							//console.log($(this).attr('id'));

							var mapId = $(this).attr("id");

							app.maps[mapId] = new staticMap(
								"#" + mapId,
								app.dispatcher
							);
						});

						//app.londonmap = new staticMap(DOM.maps.london, app.dispatcher);
						//app.bahrainmap = new staticMap(DOM.maps.bahrain, app.dispatcher);
						break;

					//::::::::::::::::::::::::::::::::::::::::::::
					//! - PAGE - PORTFOLIO EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "portfolio":
						$(DOM.maps.el).each(function () {
							//console.log($(this).attr('id'));

							var mapId = $(this).attr("id");

							app.maps[mapId] = new staticMap(
								"#" + mapId,
								app.dispatcher
							);
						});

						break;

					//::::::::::::::::::::::::::::::::::::::::::::
					//! - PAGE - MAP EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "map":
						// Load the map
						app.maps.portfolio = new portfolioMap(
							DOM.maps.portfolio,
							app.filterQueries,
							app.dispatcher
						);

						// make filte rbar Sticky
						var filterOffset =
							$(DOM.ui.navbar).height() +
							$("#wpadminbar").height();
						$("#stickyFilter").sticky({
							topSpacing: filterOffset,
							zIndex: 10,
						});

						app.dispatcher.addEventListener(
							EVENTS.WINDOW.RESIZE,
							function (event, data) {
								$("#stickyFilter").sticky("update");
							}.bindX(this)
						);

						// Get current queries for filter bar
						app.getFilterQueries();

						// Load the filters
						app.portfolioFilters = new portfolioFilters(
							["service", "sector"],
							null,
							app.filterQueries,
							true,
							app.dispatcher
						);

						// Get posts for map and filters
						var query =
							app.wp.siteUrl +
							"/wp-json/wp/v2/projects?per_page=100&fields=id,sector,service,location_prime,acf.coordinates,content.protected";

						app.loadRestPosts("portfolio", query, "acf"); // dispatch event to app.portfolioFilters & app.maps.portfolio

						break;
				}

				break;

			//::::::::::::::::::::::::::::::::::::::::::::
			//! - NEWS  EVENTS
			//::::::::::::::::::::::::::::::::::::::::::::
			case "news":
				// Type of page
				switch (d[2]) {
					//::::::::::::::::::::::::::::::::::::::::::::
					//! - NEWS - ARCHIVE EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "archive":
						$(DOM.archives.pageLimit).removeClass("is-loading");

						var filterOffset =
							$(DOM.ui.navbar).height() +
							$("#wpadminbar").height();
						$("#stickyFilter").sticky({
							topSpacing: filterOffset,
							zIndex: 10,
						});

						app.dispatcher.addEventListener(
							EVENTS.WINDOW.RESIZE,
							function (event, data) {
								$("#stickyFilter").sticky("update");
							}.bindX(this)
						);

						app.dispatcher.addEventListener(
							EVENTS.WINDOW.SCROLL,
							function (event, data) {
								if (
									app.checkObjinWindow(
										DOM.btn.infinscroll,
										data
									)
								) {
									//console.log('TRUE');
									app.loadmoreInit(
										true,
										"grids/grd-news.twig"
									);
								}

								//app.loadmoreScrollTrack(); // scroll trackign for adressbar page updating
							}
						);

						app.filterCat(DOM.archives.catFilter);

						break;

					//::::::::::::::::::::::::::::::::::::::::::::
					//! - NEWS - YEAR ARCHIVE EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "archive-year":
						var filterOffset =
							$(DOM.ui.navbar).height() +
							$("#wpadminbar").height();
						$("#stickyFilter").sticky({
							topSpacing: filterOffset,
							zIndex: 10,
						});

						app.dispatcher.addEventListener(
							EVENTS.WINDOW.RESIZE,
							function (event, data) {
								$("#stickyFilter").sticky("update");
							}.bindX(this)
						);

						// Load year filters
						app.filterYear(DOM.archives.yearFilters);

						break;

					case "archive-author":
						break;

					//::::::::::::::::::::::::::::::::::::::::::::
					//! - NEWS - SINGLE EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "single":
						// Check for any maps
						$(DOM.maps.el).each(function () {
							var mapId = $(this).attr("id");

							app.maps[mapId] = new staticMap(
								"#" + mapId,
								app.dispatcher
							);
						});

						break;
				}

				break;

			//::::::::::::::::::::::::::::::::::::::::::::
			//! - PROJECTS  EVENTS
			//::::::::::::::::::::::::::::::::::::::::::::
			case "projects":
				// Type of page
				switch (d[2]) {
					//::::::::::::::::::::::::::::::::::::::::::::
					//! - PROJECTS - ARCHIVE EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "archive":
						$(DOM.archives.pageLimit).removeClass("is-loading");

						app.dispatcher.addEventListener(
							EVENTS.WINDOW.SCROLL,
							function (event, data) {
								if (
									app.checkObjinWindow(
										DOM.btn.infinscroll,
										data
									)
								) {
									//console.log('TRUE');
									app.loadmoreInit(
										true,
										"grids/grd-portfolioList.twig"
									);
								}

								//app.loadmoreScrollTrack(); // scroll trackign for adressbar page updating
							}
						);

						$(DOM.maps.el).each(function () {
							var mapId = $(this).attr("id");

							app.maps[mapId] = new staticMap(
								"#" + mapId,
								app.dispatcher
							);
						});

						app.getFilterQueries();

						//console.log('## SENDIGN QUERIES TO FILTERS');
						//console.log(app.filterQueries);

						app.portfolioFilters = new portfolioFilters(
							["service", "sector"], // ['location_prime', 'service', 'sector'], // filters to use
							null, //'location_prime', // Master filter
							app.filterQueries, // page queries

							false, // Require 'apply' button
							app.dispatcher // dispatcher
						);

						var filterOffset =
							$(DOM.ui.navbar).height() +
							$("#wpadminbar").height();

						$("#stickyFilter").sticky({
							topSpacing: filterOffset,
							zIndex: 10,
						});

						app.dispatcher.addEventListener(
							EVENTS.WINDOW.RESIZE,
							function (event, data) {
								$("#stickyFilter").sticky("update");
							}.bindX(this)
						);

						// Get posts for map and filters
						var query =
							app.wp.siteUrl +
							"/wp-json/wp/v2/projects?per_page=100&fields=id,sector,service,location_prime";

						app.loadRestPosts("portfolio", query); // dispatch event to app.portfolioFilters & app.maps.portfolio

						break;

					//::::::::::::::::::::::::::::::::::::::::::::
					//! - PROJECTS - SINGLE EVENTS
					//::::::::::::::::::::::::::::::::::::::::::::
					case "single":
						// check for maps
						$(DOM.maps.el).each(function () {
							var mapId = $(this).attr("id");

							app.maps[mapId] = new staticMap(
								"#" + mapId,
								app.dispatcher
							);
						});

						app.teamList();
						break;
				}

				break;
		}
	},

	//////////////////////////////////////////////
	//! SITE FUNCTIONS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.menuToggle
	// Toggels menu open/close
	//::::::::::::::::::::::::::::::::::::::::::::
	menuToggle: function (open) {
		// alert('TOGGLING MENU');

		// Open It
		if (open && !app.menuPanel.isOpen) {
			$(DOM.ui.mnuPanel).addClass("is-open");
			$(DOM.btn.menuTogg).addClass("is-open");
			$(DOM.ui.overlay).addClass("is-open");

			app.menuPanel.isOpen = true;
			app.scrollLock(true);
		}

		// Close it
		else if (!open && app.menuPanel.isOpen) {
			app.scrollLock(false);
			$(DOM.ui.mnuPanel).removeClass("is-open");
			$(DOM.btn.menuTogg).removeClass("is-open");
			$(DOM.ui.overlay).removeClass("is-open");

			app.menuPanel.isOpen = false;
		}
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.searchToggle
	// Toggels search panel open/close
	//::::::::::::::::::::::::::::::::::::::::::::
	searchToggle: function (dir) {
		if (
			dir === true ||
			(dir === undefined && app.searchPanel.isOpen == false)
		) {
			$(DOM.ui.searchPanel).addClass("is-open");
			app.searchPanel.isOpen = true;
			app.searchPanel.scrollPos = $(window).scrollTop(); // track scroll position
		} else if (
			dir === false ||
			(dir === undefined && app.searchPanel.isOpen == true)
		) {
			$(DOM.ui.searchPanel).removeClass("is-open");
			app.searchPanel.isOpen = false;
		}
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.modalOpen
	// Toggels modal panel
	//::::::::::::::::::::::::::::::::::::::::::::
	modalOpen: function (src, content) {
		//console.log(src);

		var content = content;

		if (src.attr("data-modalteam")) {
			app.modalTeamImg(src);
		}

		// Open it
		if (!app.modal.isOpen) {
			var $contentDest = $(DOM.modal.content).find(".simplebar-content");

			if (content === null) {
				// console.log("CONTENT NOT SUPPLIED");
				content = src.find(DOM.modal.source).html();
			}

			//console.log(content);

			$(".simplebar-scroll-content").scrollTop(0);

			//$(DOM.modal.filters.content).hide();

			$contentDest.html(""); // clear existing content

			$contentDest.html(content); // add new content

			//app.scroll.modal.recalculate();

			// Open the window
			$(DOM.ui.overlay).addClass("is-open");
			$(DOM.modal.ele).addClass("is-open");
			$(DOM.page.el).addClass("is-locked "); // unlock page for interaction
			app.scrollLock(true);
			app.modal.isOpen = true;

			var browseClass = DOM.archives.teamitems;

			if (src.hasClass("js-teamItem")) {
				$(DOM.modal.browse).addClass("is-active");
			}
		}
	},

	modalTeamImg: function ($mem) {
		//console.log($mem);
		if ($mem.attr("data-mdlloaded") == "false") {
			var $mdlCont = $("#mdl-" + $mem.attr("id"));
			var imgSm = $mem.attr("data-imgSm");
			var imgMd = $mem.attr("data-imgMd");
			var imgLg = $mem.attr("data-imgLg");

			var img =
				'<img alt="" class="cont-mast__img" ' +
				'src="' +
				imgSm +
				'"' +
				'srcset="' +
				imgSm +
				" 940w," +
				imgMd +
				" 1260w," +
				imgLg +
				" 2560w" +
				'" />';

			$mdlCont.prepend(img);
			$mem.attr("data-mdlloaded", "true");

			// DO project images

			$mdlCont.find("aside").each(function () {
				//console.log('HERE');
				//console.log($(this));

				var bkgId = "#" + $(this).attr("id") + "_bkg";
				var imgSm = $(this).attr("data-imgsm");
				var imgMd = $(this).attr("data-imgmd");
				var imgLg = $(this).attr("data-imglg");

				var style =
					"<style>" +
					bkgId +
					" { background-image:url(" +
					imgSm +
					"); }" +
					"@media screen and (min-width: 768px){ " +
					bkgId +
					" {background-image:url(" +
					imgMd +
					");}}" +
					"@media screen and (min-width: 992px){ " +
					bkgId +
					" {background-image:url(" +
					imgLg +
					");}}" +
					"</style>";

				$(this).prepend(style);
			});
		}
	},

	modalFilters: function (open) {
		//$(DOM.modal.content).hide();
		if (!app.modal.isOpen) {
			app.scrollLock(true);
			$(".simplebar-scroll-content").scrollTop(0);

			// Open the window
			$(DOM.ui.overlay).addClass("is-open");
			$(DOM.modal.filters.ele).addClass("is-open");
			/*
						$(DOM.page.el).addClass('is-locked '); // unlock page for interaction
						app.scrollLock(true);
			*/
			app.modal.isOpen = true;
			app.modal.isFilter = true;
		}
	},

	modalCLose: function () {
		if (app.modal.isOpen) {
			if (!app.modal.isFilter) {
				$(DOM.modal.ele).removeClass("is-open");

				$(DOM.page.el).removeClass("is-locked "); // unlock page for interaction
				app.scrollLock(false);
			} else {
				$(DOM.modal.filters.ele).removeClass("is-open");
				app.modal.isFilter = false;
				app.scrollLock(false);
			}

			app.modal.isOpen = false;

			$(DOM.ui.overlay).removeClass("is-open");
			$(DOM.modal.browse).removeClass("is-active");
		}
	},

	getTeamID: function ($el) {
		// Add to array function

		//console.log('ADDING: '+$el);
		var id = String($el.attr("id")); // get the id
		id = id.replace("team-", ""); // remove uneeded part of string
		return id; // push to $items[]
	},

	teamList: function () {
		var items = [];

		// Get all els
		$(DOM.archives.teamItems).each(function () {
			//console.log($(this));
			var $item = $(this); // shortcut
			var id = app.getTeamID($item);
			items.push(id);
		});

		app.team = items;
		app.teamBrowse();
	},

	teamBrowse: function () {
		var el = DOM.archives.teamItems;

		//app.teamList(el, exclude); // list team

		// Change Modal function
		var changeTeam = function (index) {
			$(DOM.modal.content).animate(
				{
					opacity: 0,
				},
				500,
				function () {
					var target = el + "#team-" + $items[index];
					app.modalTeamImg($(target));

					var $contentDest = $(DOM.modal.content).find(
						".simplebar-content"
					);
					var contentSrc = $(target).find(DOM.modal.source).html(); // get new content

					//console.log($(target));

					$(".simplebar-scroll-content").scrollTop(0);

					$contentDest.html(""); // clear existing content

					$contentDest.html(contentSrc); // add new content

					//app.modal.scroll.recalculate();

					$(DOM.modal.content).animate(
						{
							opacity: 1,
						},
						500
					);
				}
			);
		};

		// EVENT LISTENERS
		$(DOM.modal.next).click(function () {
			$items = app.team;
			//alert($items);
			// get ID Get ID of current modal
			var openID = String(
				$(DOM.modal.content).find(".mdl-team").attr("id")
			);
			openID = openID.replace("mdl-team-", ""); // remove uneeded part of string

			// Find the index
			var index = $.inArray(openID, $items);
			if (index == $items.length - 1) {
				index = 0; // if last set to first
			} else {
				index++; // set to next
			}

			changeTeam(index); // change modal
		});

		$(DOM.modal.prev).click(function () {
			$items = app.team;

			// Get ID of current modal
			var openID = String(
				$(DOM.modal.content).find(".mdl-team").attr("id")
			);
			openID = openID.replace("mdl-team-", ""); // remove uneeded part of string

			//alert(openID);

			var index = jQuery.inArray(openID, $items);
			//alert(index);
			if (index == 0) {
				index = $items.length - 1; // if first set to last
			} else {
				index--; // set to prev
			}

			changeTeam(index); // change modal
		});
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! BMNAME
	//::::::::::::::::::::::::::::::::::::::::::::
	getFilterQueries: function () {
		//console.log('## LOADING QUERIES');

		// Get query terms
		var $locQ = $(DOM.queries + "[data-tax=location_prime]");
		var $servQ = $(DOM.queries + "[data-tax=service]");
		var $secQ = $(DOM.queries + "[data-tax=sector]");

		// Store IDS
		var locTerms = [];
		var servTerms = [];
		var secTerms = [];

		// Push all the term IDS
		$locQ.each(function () {
			locTerms.push(parseInt($(this).attr("data-termid")));
		});

		$servQ.each(function () {
			servTerms.push(parseInt($(this).attr("data-termid")));
		});

		$secQ.each(function () {
			secTerms.push(parseInt($(this).attr("data-termid")));
		});

		// Check location_prime
		if (locTerms.length > 0) {
			//console.log('LOCATION DETECTED');
			app.filterQueries.location_prime = locTerms;
		}

		// Check service
		if (servTerms.length > 0) {
			app.filterQueries.service = servTerms;
		}

		// Check sector
		if (secTerms.length > 0) {
			app.filterQueries.sector = secTerms;
		}

		//console.log('## FILTERS LOADED');
		//console.log(app.filterQueries);
	},

	filterCat: function (filter) {
		//alert('FILTER READY');
		$filter = $(filter); // sett he filter

		$filter.change(function () {
			// on change

			//alert('FILTER CHANGING: ' + $(this).val() );
			var newCat = $(this).val();

			var loc = window.location.href; // get current url

			if (newCat === "all") {
				newCat = "";
			} else {
				newCat = "?category_name=" + newCat;
			}

			var re = new RegExp("\\?category_name=\\w*");

			loc = loc.replace(re, ""); // remove any current query
			loc = loc + newCat; // add new query

			window.location = loc; // go new year url
		});
	},
	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.filterYear
	// Year filter for news
	//::::::::::::::::::::::::::::::::::::::::::::
	filterYear: function (filter) {
		//alert('FILTER READY');
		$filter = $(filter); // sett he filter

		$filter.change(function () {
			// on change

			//alert('FILTER CHANGING: ' + $(this).val() );

			var loc = window.location.href; // get current url

			var year = $(this).val(); // get year from option

			loc = loc.replace(/[0-9]{4}/, year); // update url

			window.location = loc; // go new year url
		});
	},
	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.filterTeam
	// Filters for team
	//::::::::::::::::::::::::::::::::::::::::::::
	filterTeam: function () {
		//console.log(filters+'/'+items+'/'+data+'/'+term);

		var $filters = $(DOM.archives.teamFilters);
		var $items = $(DOM.archives.teamItems);
		var term = "directors";

		//console.log($items);

		var groupIds = [];

		// Filter Items
		var filter = function (term) {
			groupIds = []; // rest group ids

			if (term != "all") {
				$(this).addClass("is-selected"); // activate current filter

				$items.each(function () {
					var $item = $(this);

					var $itemroot = $item.closest(DOM.ui.gridItem);

					$itemroot.addClass("is-filteredOut");

					if (
						$item.data("teamgroup") == term ||
						$item.data("teamgroup") == "all"
					) {
						// check each items data against the term
						$itemroot.removeClass("is-filteredOut");
						app.teamAddImg($item);
						var id = app.getTeamID($item);

						groupIds.push(id);
					}
				});
			} else {
				$items.closest(itemRoot).removeClass("is-filteredOut");

				var id = app.getTeamID($item);
				groupIds.push(id);
			}

			//alert(groupIds);
			app.team = groupIds;
			//alert(app.team);
		};

		// Run filter if default term is passed as arg

		$filters.val(term);
		$filters.selectric("refresh"); // update selectric.js display
		filter(term); // run filter on items
		app.teamBrowse(); //init browsing

		// Click events for filter buttons
		$filters.change(function () {
			var term = $(this).val(); // get term from data

			filter(term); // run filter on items
		});
	},
	test: function () {
		//alert('HELLO');
	},

	teamAddImg: function ($mem) {
		if ($mem.attr("data-imgloaded") === "false") {
			//console.log($mem);
			var bkgId = "#" + $mem.attr("id") + "_bkg";
			var imgSm = $mem.attr("data-imgSm");
			var imgMd = $mem.attr("data-imgMd");
			var imgLg = $mem.attr("data-imgLg");

			var style =
				"<style>" +
				bkgId +
				" { background-image:url(" +
				imgSm +
				"); }" +
				"@media screen and (min-width: 768px){ " +
				bkgId +
				" {background-image:url(" +
				imgMd +
				");}}" +
				"@media screen and (min-width: 992px){ " +
				bkgId +
				" {background-image:url(" +
				imgLg +
				");}}" +
				"</style>";

			//console.log(style);

			$mem.prepend(style);
			$mem.attr("data-imgloaded", "true");
		}
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! BMNAME
	//::::::::::::::::::::::::::::::::::::::::::::
	loadRestPosts: function (name, query, haveField, page) {
		//console.log('## LOADING POSTS');

		// Check for page numbers
		if (!page) {
			app.posts[name] = [];
			page = 1;
		}

		// Add pages to query
		query = query + ",status,content.protected&page=" + page;
		//console.log(query);
		// GET THE MARKER DATA
		app.loadJSON(query, function (response, totalPages) {
			page++; // next page

			var data = JSON.parse(response); // get data

			var posts = app.posts[name].concat(data);
			app.posts[name] = posts;

			// Check if more pages of results to load
			if (totalPages >= page) {
				app.loadRestPosts(name, query, haveField, page);
			}

			// If no more pages..
			else {
				// If field requried removbe any posts which dont have it

				if (app.posts[name].length > 0) {
					// Remove private and password protected posts
					for (i = 0; i < app.posts[name].length; i++) {
						//console.dir(app.posts[name][i]);

						// Remove private posts from loop
						if (app.posts[name][i].staus == "private") {
							app.posts[name].splice(
								$.inArray(app.posts[name][i], app.posts[name]),
								1
							);
						}

						// Remove password protected posts from loop
						if (
							app.posts[name][i].content &&
							app.posts[name][i].content.protected
						) {
							app.posts[name].splice(
								$.inArray(app.posts[name][i], app.posts[name]),
								1
							);
						}

						// Custom field value removal
						if (haveField) {
							if (app.posts[name][i][haveField] == null) {
								app.posts[name].splice(
									$.inArray(
										app.posts[name][i],
										app.posts[name]
									),
									1
								);
							}
						}
					}

					//console.log('API OBJECTS LOADED:');
					//console.dir(app.posts[name]);

					app.dispatcher.dispatch(
						EVENTS.API.LOAD + "_" + name,
						app.posts[name]
					);
				}
			}
		});
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! LOAD JSON FOR POSTS FROM REST
	//::::::::::::::::::::::::::::::::::::::::::::
	loadJSON: function (url, callback) {
		//this.spinner(true);// hide spinner

		var xobj = new XMLHttpRequest();
		xobj.overrideMimeType("application/json");

		xobj.open("GET", url, true);

		xobj.setRequestHeader("Access-Control-Allow-Headers", "*");
		var totalPages = 1;

		xobj.onreadystatechange = function () {
			if (xobj.readyState == xobj.HEADERS_RECEIVED) {
				totalPages = xobj.getResponseHeader("x-wp-totalpages");
			}

			if (xobj.readyState == 4 && xobj.status == "200") {
				//this.spinner(false); // hide spinner
				callback(xobj.responseText, totalPages);
			}
		}.bindX(this);

		xobj.ontimeout = function () {
			app.dispatcher.dispatch(EVENTS.API.FAILED);
		};

		xobj.send(null);
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.loadmoreInit
	// Infinate scrolling setup and initialisation
	//::::::::::::::::::::::::::::::::::::::::::::
	loadmoreInit: function (dir, template) {
		// dir = true to go forwards, false to go backwards

		if (app.page.busy) {
			return;
		} else {
			app.page.busy = true; // make page busy

			var ajaxurl = app.wp.ajaxUrl; // get ajaxurl
			var type = app.page.postType; // get post type
			var filter;

			var currPage;
			var nextPage;

			/*
						if (dir) { // foreward (dir == true)
			*/
			currPage = app.page.paged.max;
			nextPage = app.page.paged.max + 1;

			/* - uncomment for multi dir + page tracking infin scroll
						} else { // Backwards (dir == false)
							page = app.page.paged.min;
							nextPage = app.page.paged.min - 1;
						}
			*/
			var filters = [];

			// Get all the taxonomy filters
			$(DOM.archives.postFilter).each(function () {
				var filter = [];
				filter.push($(this).data("tax"), $(this).data("term"));
				filters.push(filter);
			});

			// Load button activity
			$(DOM.btn.infinscroll).addClass("is-loading");

			// console.log(page + ' / '+ nextPage + ' / ' + ajaxurl + ' / '+ type);

			//console.log('BBBB');

			// AJAX CALL (template function.php)
			$.ajax({
				url: ajaxurl,
				type: "post",
				dataType: "html",
				isLocal: true,
				cache: false,
				headers: {
					"cache-control": "no-cache",
				},

				data: {
					method: "POST",
					page: currPage,
					action: "archive_load_more",
					type: type,
					more: dir,
					filters: filters,
					template: template,
				},
				error: function (res) {
					console.log("ERROR");
					console.log(res);
				},
				success: function (res) {
					//console.log('loading:\n');
					//console.log(res);

					// If there is content
					if (res != 0) {
						// paginate the html block in res
						var newPage = res.replace(
							/data\-pageurl\=\"\/(page\/\d*\/)?"/,
							'data-pageurl="/page/' + nextPage + '/"'
						).replace(/http:\/\//gi, "https://");

						/* - uncomment for multi dir + page tracking infin scroll
											// Check Direction
												if (dir) { // forewards (dir == true)
						*/
						app.page.paged.max++; // update page tracking
						/* - uncomment for multi dir + page tracking infin scroll
												} else { // backwards (dir == false)
													app.page.paged.min--; // updat epage tracking
												}


												if (app.page.paged.min == 1) { // if you have moved back to 1st page
													$(DOM.btn.loadprev).hide();
												}
						*/
						// Delay and load new content to DOM
						setTimeout(function () {
							app.loadmoreAdd(newPage, dir);
						}, 1000);

						// If no content
					} else {
						app.page.busy = false; // make page NOT busy

						$(DOM.btn.infinscroll).addClass("is-atend");
						//	console.log('NO MORE POSTS');
					}
				},
			});
		}
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.loadmoreAdd
	// Add new posts to DOM
	//::::::::::::::::::::::::::::::::::::::::::::
	loadmoreAdd: function (newPage, dir) {
		// dir = true to go forwards, false to go backwards

		if (dir) {
			$(DOM.archives.postGird).append(newPage); // add new block to DOM

			// Pass coulors down to CTA's
			$(DOM.archives.postGird + " .btn").css(
				"color",
				app.page.currentColor
			);
		} else {
			$(DOM.archives.postGird).prepend(newPage); // add new block to DOM
		}

		setTimeout(function () {
			$(DOM.archives.pageLimit).removeClass("is-loading");
			$(DOM.btn.infinscroll).removeClass("is-loading");
		}, 200);

		app.page.busy = false; // make page NOT busy
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.loadmoreScrollTrack
	// Track the current scroll position and amend url to show page in viewport
	//::::::::::::::::::::::::::::::::::::::::::::
	/*
		loadmoreScrollTrack:function(){
			$(window).scroll(function(){
				var scroll = $(window).scrollTop();

				if (Math.abs(scroll - app.page.last_scroll) > $(window).height()*0.1 ) {

					app.page.last_scroll = scroll;

					$('.js-pg-limit').each(function(index){

						if( app.pageIsVisible( $(this) )) {
							console.log($(this) + 'visible');

							history.replaceState(null, null, 'http://localhost/assael-wp/wp/news'+$(this).attr('data-pageurl'));
							return(false);
						}

					});

				}

				//app.page.last_scroll
			});
		},
	*/

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.pageIsVisible
	// Check Infinite scroll page is visible in viewport
	//::::::::::::::::::::::::::::::::::::::::::::
	/*
		pageIsVisible: function(el) {

			var scroll_pos = $(window).scrollTop();
			var window_h = $(window).height();
			var el_top = $(el).offset().top;
			var el_H = $(el).height();
			var el_bottom = el_top + el_H;

			return ((el_bottom - el_H*0.25 > scroll_pos) && ( el_top < ( scroll_pos + 0.5*window_h)));
		},
	*/

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - app.checkObjinWindow
	// Check and DOM element is visible in viewport
	//::::::::::::::::::::::::::::::::::::::::::::
	checkObjinWindow: function (el, data) {
		//console.log('checking:' +el);

		var wTop = data[0];
		var wH = $(window).height();
		var wBot = data[1];

		var elTop = $(el).offset().top;
		var elH = $(el).height();
		var elBot = elTop + elH;

		//console.log(el+': '+elTop+' : '+elBot);

		if (elTop > wTop + wH * 0.05 && elBot < wBot - wH * 0.05) {
			return true;
			//console.log('INSIDE!');
		}
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - videoSrcCheck
	// Choose and play video bkg source based upon device.
	//::::::::::::::::::::::::::::::::::::::::::::
	videoSrcCheck: function (el) {
		var $vid = el;
		var $vidsrc = el.children("source");
		var src = $vid.data("srchd");

		if (Detectizr.device.type === "mobile" && $vid.data("srcsd")) {
			src = $vid.data("srcsd");
		}

		$vidsrc.attr("src", src);
		$vid[0].load(src);

		$vid.fadeIn("fast");
		$vid.get(0).play();
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! - scrollLock
	// Lock the page element form scrolling
	//::::::::::::::::::::::::::::::::::::::::::::
	scrollLock: function (lock) {
		//console.log('Stored:' + app.scrollPos.stored);
		// dir == true to lock scroll
		if (lock) {
			app.scrollPos.stored = app.scrollPos.tracked;

			//console.log('Tracked: '+app.scrollPos.tracked);

			var offset = 0;

			// MUST BE OFFSET BY HEIGHT OF #wpadminbar if active!
			if (jQuery("#wpadminbar")) {
				offset = jQuery("#wpadminbar").height();
			}

			//alert(offset + '/' + app.scrollPos.tracked);

			$(window).scrollTop(0);

			$(DOM.page.el).css({
				position: "fixed",
				top: offset - app.scrollPos.tracked,
				left: 0,
				"overflow-y": "scroll",
				//'height': '100%'
			});
		} else {
			//console.log('CLOSING: '+app.scrollPos.stored);
			$(DOM.page.el).css({
				position: "",
				top: "",
				left: "",
				"overflow-y": "",
			});
			$(window).scrollTop(app.scrollPos.stored);
		}
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Slideshow functionality
	//::::::::::::::::::::::::::::::::::::::::::::
	slideShow: function ($show) {
		var trans_dur = 300;

		var slide_dur = $show.attr("data-slidedur") * 1000 + trans_dur;

		var count = 0;
		var current = 0;
		var $slides = [];
		//console.log('DURATION:'+slide_dur);

		$show.find("div").each(function () {
			$(this).hide();
			$slides.push($(this));
			count++;
		});
		//console.log('count:'+count);
		//console.log($slides);

		$slides[0].show().css("z-index", 1);

		var switchSlide = function () {
			//console.log('current:'+current);
			var next = 0;

			if (current < count - 1) {
				next = current + 1;
			}

			//console.log('next:'+next);

			$($slides[current]).css("z-index", 0);
			$($slides[next])
				.css("z-index", 1)
				.fadeIn(trans_dur, function () {
					$($slides[current]).hide();

					current = next;
				});
		};

		setInterval(function () {
			switchSlide();
		}, slide_dur);
	},

	newfunction: function ($marker, map) {},
}; //END app();

//////////////////////////////////////////////
//! NON APP FUNCTIONS & EVNT TRIGGERS
//////////////////////////////////////////////

window.addEventListener("pageshow", function (event) {
	var historyTraversal =
		event.persisted ||
		(typeof window.performance != "undefined" &&
			window.performance.navigation.type === 2);
	if (historyTraversal) {
		// Handle page restore.
		app.init();
	}
});

//::::::::::::::::::::::::::::::::::::::::::::
//! JQUERY DOC READY
//::::::::::::::::::::::::::::::::::::::::::::
jQuery(document).ready(function ($) {
	app.init();

	//::::::::::::::::::::::::::::::::::::::::::::
	//! WINDOW RESIZE EVENTS
	//::::::::::::::::::::::::::::::::::::::::::::
	var rs;
	$(window).resize(function () {
		clearTimeout(rs);
		rs = setTimeout(function () {
			app.dispatcher.dispatch(EVENTS.WINDOW.RESIZE);
		}, 250);
	});

	//::::::::::::::::::::::::::::::::::::::::::::
	//! WINDOW VISIBILITY EVENTS
	//::::::::::::::::::::::::::::::::::::::::::::
	$(document).on("visibilitychange", function () {
		if (document.hidden) {
			app.dispatcher.dispatch(EVENTS.WINDOW.BLUR);
		} else {
			app.dispatcher.dispatch(EVENTS.WINDOW.FOCUS);
		}
	});

	//::::::::::::::::::::::::::::::::::::::::::::
	//! WINDOW SCROLL EVENT
	//::::::::::::::::::::::::::::::::::::::::::::
	$(window).on("resize scroll", function () {
		//console.log('scroll');
		var wTop = $(window).scrollTop();
		var wBot = wTop + $(window).height();
		//console.log('scrolling: '+ wTop + ' : ' + wBot);
		app.scrollPos.tracked = wTop; // track the scroll pos for other functions
		//console.log(app.scrollPos.tracked);
		app.dispatcher.dispatch(EVENTS.WINDOW.SCROLL, [wTop, wBot]); // trigger events on scroll and pass details
	});
}); // close jquery

//::::::::::::::::::::::::::::::::::::::::::::
//! SCOPE FUNCTION
//::::::::::::::::::::::::::::::::::::::::::::
Function.prototype.bindX = function (scope) {
	var _function = this;

	return function () {
		return _function.apply(scope, arguments);
	};
};
